import { useLocation } from 'react-router-dom';
import careerpagebg from "../../../assets/career-development.png";
import { useEffect } from "react";
import { Typography, Box, Container, Paper, Divider } from '@mui/material';

export default function Job_Details() {
  const location = useLocation();
  const job = location.state?.data || {};

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Inline CSS for job-description */}
      <style>
        {`
          .job-description h3 {
            margin: 1em 0 0.5em 0;
            font-weight: bold;
          }

          .job-description ol,
          .job-description ul {
            margin-left: 1.5em;
            padding-left: 1.2em;
            list-style: initial !important;
          }

          .job-description li {
            margin-bottom: 0.5em;
          }

          .job-description strong {
            font-weight: bold;
          }
        `}
      </style>

      {/* Hero Banner */}
      <Box
        sx={{
          width: "100%",
          height: "250px",
          backgroundImage: `url(${careerpagebg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Job Detail Card */}
      <Container maxWidth="md" sx={{ mt: -10, mb: 5 }}>
        <Paper elevation={4} sx={{ p: 4, borderRadius: 3, boxShadow: 6 }}>
          <div
            style={{
              backgroundColor: "black",
              marginBottom: '10px',
              padding: '10px',
              borderRadius: '0px 0px 10px 10px',
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h4" fontWeight="bold" color="#fff">
              {job.jobtitle || "N/A"}
            </Typography>
          </div>

          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Department / Function:</strong> {job.department || "N/A"}
          </Typography>

          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Job Type:</strong> {job.jobtype || "N/A"}
          </Typography>

          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Location:</strong> {job.location || "N/A"}
          </Typography>

          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Qualification:</strong> {job.qualification || "N/A"}
          </Typography>

          <div >
            <Typography
              variant="body1"
              sx={{ mb: 1 }}>
              <strong>Description:</strong>
            </Typography>

            <div
              className="job-description"
              style={{
                fontSize: '0.95rem',
                lineHeight: 1.6,
              }}
              dangerouslySetInnerHTML={{
                __html: job.jobdescription || "No description available",
              }}
            />
          </div>

          <Typography variant="body1" sx={{ mb: 1}}>
            <strong>Experience:</strong> {job.experience || "N/A"}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1}}>
            <strong>Budget:</strong> {job.budget || "N/A"}
          </Typography>
          <Divider sx={{ my: 3 }} />

          {/* Apply Button */}
          <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
            <button
              onClick={() => {
                window.open(
                  'https://mail.google.com/mail/?view=cm&fs=1&to=HR@simplifyingskills.com',
                  '_blank'
                );
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 6px 14px rgba(0, 0, 0, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.1)';
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = 'scale(0.92)';
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                background: 'black', 
                border: 'none',
                borderRadius: '30px',
                padding: '15px 30px',
                color: '#fff',
                fontWeight: 500,
                fontSize: '16px',
                fontFamily: 'Segoe UI, sans-serif',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                cursor: 'pointer',
                transition: 'transform 0.15s ease, box-shadow 0.2s ease',
                outline: 'none',
              }}
            >
              Apply Now
            </button>
          </div>
        </Paper>
      </Container>
    </div>
  );
}
